import "../styles/About.css";
import rocket from '../media/rocket.png'
import atom from "../media/atom.png";
import figma from "../media/figma.png"

import { Slide } from "react-awesome-reveal";
import { DiHtml5, DiCss3, DiReact, DiMongodb, DiSass, DiIllustrator, DiPhotoshop, DiPostgresql } from "react-icons/di";
import { IoLogoJavascript, IoLogoFirebase } from "react-icons/io5";
import { Link } from "react-router-dom";

function About() {
    return (
        <div className='about__container'>
            <div className='about__inner'>
                <div className="about__header">
                    <img src={rocket} alt="rocket" />
                    <h1>WE ARE ARTEMIS</h1>
                    <div className='arrow__right'>
                        <img src={rocket} alt="rocket" />
                    </div>
                </div>

                <p>Zenica (Bosnia and Herzegovina) based company committed to crafting ideas into lovable products. We are a full-service agency taking good care of your projects. Coding is what we love to do most, but we do much more than that. Your projects become our projects; your business becomes our business. We nurture it, test it, polish it, have it constantly on our minds, and, basically, care about it the way we care about our company and our team. Perseverance and commitment to see things through make success possible and create an environment where delivering great products and services is the norm. We commit ourselves to whatever we do – in the best way possible. Whatever we do, we do it as a team together-regardless of how different we are.</p>

                <img src={atom} className='about__img' alt="" />


                <div className="about__technologies">
                    <img src={rocket} alt="rocket" />
                    <h1>TECHNOLOGIES</h1>
                    <div className='arrow__right'>
                        <img src={rocket} alt="rocket" />
                    </div>
                </div>

                <div className='about__icons'>
                    <Slide direction='up'>
                        <DiHtml5 style={{ color: "#e34c26" }} />
                    </Slide>
                    <Slide direction='up' delay='10'>
                        <DiCss3 style={{ color: "#264de4" }} />
                    </Slide>
                    <Slide direction='up' delay='15'>
                        <IoLogoJavascript style={{ color: "#f0db4f" }} />
                    </Slide>
                    <Slide direction='up' delay='20'>
                        <DiReact style={{ color: "#00d8ff" }} />
                    </Slide>
                    <Slide direction='up' delay='25'>
                        <DiMongodb style={{ color: "#4db33d" }} />
                    </Slide>
                    <Slide direction='up' delay='30'>
                        <IoLogoFirebase style={{ color: "#F57C00" }} />
                    </Slide>
                    <Slide direction='up' delay='35'>
                        <DiPostgresql style={{ color: "#0064a5" }} />
                    </Slide>
                    <Slide direction='up' delay='40'>
                        <DiSass style={{ color: "#cd6799" }} />
                    </Slide>
                    <Slide direction='up' delay='45'>
                        <DiIllustrator style={{ color: "#faa625" }} />
                    </Slide>
                    <Slide direction='up' delay='50'>
                        <DiPhotoshop style={{ color: "#80b5e2" }} />
                    </Slide>
                    <Slide direction='up' delay='55'>
                        <img src={figma} alt="" style={{ height: "3.6rem" }} />
                    </Slide>
                </div>

                <div className="about__what__we__do">
                    <img src={rocket} alt="rocket" />
                    <h1>WHAT WE DO</h1>
                    <div className='arrow__right'>
                        <img src={rocket} alt="rocket" />
                    </div>
                </div>

                <p>We view every client we collaborate with or product we develop as an opportunity to show our passion for the latest technologies, which sparks our curiosity, frees our analytical minds and stretches our creative side. That's how we grow and demonstrate our ability to deliver amazing services. We’re geeks with an engineering approach (development, quality, operations and support) at our core. We offer a whole spectrum of services to make sure your SDLC is implemented in the right way from the beginning till the end. As market and businesses continuously change, companies are constantly being pushed to re-evaluate and renew all aspects of their organization: core business, operations, customer support, supply chain, resource management, delivery etc.</p>


                <div className='about__team'>
                    <div className="about__text">
                        <p>Together we hope to achieve great things and deliver unique products that will be representative of our hard work and determination.</p>
                    </div>
                    <Link to="/team" className='about__btn'>
                        Meet Us
                    </Link>
                </div>

                <img src={atom} className='about__img' alt="" />
            </div>
        </div >
    )
}

export default About
